const fontDisplayTypes = {
  HEADING_1: 'Heading 1',
  HEADING_2: 'Heading 2',
  HEADING_3: 'Heading 3',
  HEADING_4: 'Heading 4',
  HEADING_5: 'Heading 5',
  HEADING_6: 'Heading 6',
  PARAGRAPH_1: 'Paragraph 1',
  PARAGRAPH_2: 'Paragraph 2',
  PARAGRAPH_3: 'Paragraph 3',
};

export default fontDisplayTypes;
